import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const cardVariants = {
  hidden: { opacity: 0, y: -20, scale: 0.97 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.35, ease: "easeOut", delay: 0.08 },
  },
  exit: {
    opacity: 0,
    y: -16,
    scale: 0.97,
    transition: { duration: 0.25, ease: "easeIn" },
  },
};

const textVariants = {
  hidden: { opacity: 0, y: 12 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    y: -12,
    transition: { duration: 0.2, ease: "easeIn" },
  },
};

export default function QuoteCard({ quote, onClose, onNext }) {
  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/60"
        onClick={onClose}
        aria-hidden="true"
      />
      <motion.div
        key="quote-card"
        variants={cardVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="fixed top-[72px] left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-lg"
      >
        <div className="glass rounded-2xl shadow-xl shadow-black/30 border-l-2 border-cyber-blue p-6 md:p-8 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-cyber-blue/5 rounded-full blur-3xl pointer-events-none" />

          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-400 hover:text-white transition-colors z-10"
            aria-label="Close quote"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>

          <div className="relative z-[1]">
            <svg
              className="w-8 h-8 text-cyber-blue/30 mb-3"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10H14.017zM0 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151C7.546 6.068 5.983 8.789 5.983 11H10v10H0z" />
            </svg>

            <AnimatePresence mode="wait">
              <motion.div
                key={quote?.id || "empty"}
                variants={textVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                <p className="text-base md:text-lg text-white/90 leading-relaxed font-light italic">
                  &ldquo;{quote?.text}&rdquo;
                </p>
                <p className="mt-4 text-sm text-cyber-blue font-semibold text-right">
                  &mdash; {quote?.author}
                </p>
              </motion.div>
            </AnimatePresence>

            <div className="mt-5 pt-4 border-t border-white/10 flex items-center justify-between">
              <button
                onClick={onNext}
                className="text-xs text-gray-400 hover:text-cyber-blue transition-colors flex items-center gap-1.5"
              >
                <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-current">
                  <path d="M17.65 6.35A7.96 7.96 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
                </svg>
                Next Quote
              </button>
              <Link
                to="/contact"
                onClick={onClose}
                className="text-xs text-gray-400 hover:text-tech-green transition-colors"
              >
                Need a custom quote? &rarr;
              </Link>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}
